































import {
  computed,
  defineComponent,
  ref,
  Ref,
  toRefs
} from '@nuxtjs/composition-api'
import { formFieldProps } from '~/constants/form'
import { useClassifiedForm } from '~/compositions/form'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_FORM_NS,
  FormState
} from '~/store/modules/shared/classifieds/form/state'

export default defineComponent({
  props: formFieldProps,
  components: { CFormError },
  setup(props) {
    const { name } = toRefs(props)

    const make = ref<string>('')
    const model = ref<string>('')

    function onValue(v: Ref<any>) {
      if (!v.value) {
        make.value = ''
        model.value = ''
        return
      }

      make.value = v.value.make
      model.value = v.value.model
    }
    const { debouncedValueChanged, error } = useClassifiedForm(props, {
      onValue
    })

    const { getters } = useNamespacedStore<FormState>(CLASSIFIED_FORM_NS)
    const isPartsForm = computed(() => getters('isPartsForm'))

    function updateValues() {
      debouncedValueChanged(name.value, {
        make: make.value,
        model: model.value
      })
    }

    function handleMakeInput(text: string) {
      make.value = text
      updateValues()
    }
    function handleModelInput(text: string) {
      model.value = text
      updateValues()
    }

    return {
      error,
      handleModelInput,
      handleMakeInput,
      make,
      model,
      isPartsForm
    }
  }
})
